export type RecordStringUnknown = Record<string, unknown>;
export type JSONNode = RecordStringUnknown | unknown[];
export type JSONValue = string | number | boolean | null;

export const isJSONNode = (value: unknown): value is JSONNode => {
  if (Array.isArray(value)) {
    return true;
  }
  return typeof value === 'object' && value !== null;
};
